uniform float uTime;
uniform float uSize;

attribute float aLifetime;
attribute vec3 aVelocity;
attribute float aStartTime;
attribute vec3 aColor;
attribute float aRandom;

varying float vLifetime;
varying vec3 vColor;

void main(){
    float elapsedTime = uTime - aStartTime;

    if(elapsedTime < 0.0 || elapsedTime > aLifetime){
        gl_Position = vec4(-1000., -1000., 0., 1.);
        return;
    }

    // 進行度 (0.0 to 1.0)
    float progress = elapsedTime / aLifetime;
    vLifetime = 1. - progress;
    vColor = aColor;

    // 物理的な動き
    vec3 newPosition = position;
    newPosition.y += progress * aVelocity.y * aRandom;
    newPosition.x +=  aVelocity.x * elapsedTime * 2.0;

    // ポイントのサイズを計算
    gl_PointSize = uSize * vLifetime * vLifetime;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.);
}
